import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Vacancy.css";

function Vacancy() {
  const [vacancies, setVacancies] = useState([]);
  const [message, setMessage] = useState(""); // State for status message

  // Fetch vacancies when the component mounts
  useEffect(() => {
    axios
      .get("https://weynibirhan.com.et/vacancies.php") // Use your live host URL here
      .then((response) => {
        setVacancies(response.data);
      })
      .catch((error) => {
        console.error("Error fetching vacancies:", error);
        setMessage("Failed to load vacancies. Please try again later."); // Error message
      });
  }, []);

  return (
    <div className="App">
      <h1>Job Vacancies   newlist</h1>

      {/* Display success or error message */}
      {message && <p className="message">{message}</p>}

      {/* Display Vacancies */}
      <h2>Available Vacancies</h2>
      <ul>
        {vacancies.map((vacancy) => (
          <li key={vacancy.id}>
            <h3>{vacancy.title}</h3>
            <p>Experience: {vacancy.experience} years</p>
            <p>Salary: {vacancy.salary}</p>
            <p>Gender: {vacancy.gender}</p>
            <p>Location: {vacancy.place}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Vacancy;
